import type { UseFormRegisterReturn } from 'react-hook-form';
import type { TLocalize } from '@hooks/use-localize';

const RATINGS = [1, 2, 3, 4, 5];

interface IProps {
    field: UseFormRegisterReturn;
    value: string;
    onClear: () => void;
    t: TLocalize;
}

const AgreementScale = ({ field, value, onClear, t }: IProps) => {
    // A radio that is already checked fires no change event, so clicking the rating the
    // donor already gave is what takes the answer back to unanswered.
    const handleClick = (rating: number) => {
        if (String(rating) === value) onClear();
    };

    return (
        <div className="agreement-scale">
            <div className="agreement-scale__options">
                {RATINGS.map((rating) => (
                    <label
                        key={rating}
                        className={'agreement-scale__option' + (String(rating) === value ? ' agreement-scale__option--on' : '')}
                    >
                        <input type="radio" value={rating} {...field} onClick={() => handleClick(rating)} />
                        {rating}
                    </label>
                ))}
            </div>
            <div className="agreement-scale__anchors">
                <span>{t('DashLabel_StronglyDisagree', 'Strongly disagree')}</span>
                <span>{t('DashLabel_StronglyAgree', 'Strongly agree')}</span>
            </div>
        </div>
    );
};

export default AgreementScale;
